export enum Logo {
    comet = "comet",
    nanci = "nanci",
    mba = "mba",
    mgt = "mgt",
    default = "defuult"
}
